export default {
  calculator: {
    buyLabelName: 'mam',
    swapButtonAriaLabel: 'zamień waluty miejscami',
    sellLabelName: 'otrzymam',
    currentRate: 'Aktualny kurs:',
    continueButton: 'Kontynuuj wymianę',
    miniChart: 'Mini-wykres pokazuje wahania średniego kursu z ostatnich 7 dni',
    sellTooltip:
      'To kurs sprzedaży - sprzedajemy Ci {{currency}} po {{rate}} PLN. Im niższy kurs tym bardziej korzystny dla Ciebie. Automatyczna aktualizacja co 10 sekund.',
    buyTooltip:
      'To kurs kupna -kupujemy od Ciebie {{currency}} po {{rate}} PLN. Im wyższy kurs tym bardziej korzystny dla Ciebie. Automatyczna aktualizacja co 10 sekund.',
    saleNotAvailableInfo: 'Aktualnie sprzedaż {{baseCurrency}} jest niedostępna',
    minAmount: 'Minimalna kwota wymiany to {{minAmount}} {{minCurrency}}.',
  },
  creditCalculator: {
    monthlyLoan: 'Miesięczna rata kredytu',
    loanTerm: 'Do końca kredytu pozostało',
    whichBank: 'W jakim banku spłacasz kredyt?',
    save: 'Oszczędzaj!',
    years: 'lat',
    inYear: 'w ciągu roku',
    toEnd: 'do końca kredytu',
    installmentAmount: 'Kwota raty jest za mała',
  },

  INTERNAL:
    'Pieniądze dojdą w około 30 minut od momentu kiedy otrzymamy Twój przelew, najpóźniej kolejnego dnia roboczego.',
  TODAY: 'Pieniądze dojdą najpóźniej następnego dnia roboczego.',
  TODAY_OUR: 'Pieniądze dojdą najpóźniej następnego dnia roboczego.',
  SEPA: 'Pieniądze dojdą w ciągu 1 - 2 dni roboczych.',
  SEPA_INSTANT: 'Pieniądze dojdą w około minutę.',
  SPOT: 'Pieniądze dojdą w ciągu 2 - 3 dni roboczych.',
  ELIXIR: 'Pieniądze dojdą najpóźniej następnego dnia roboczego.',
  LOCAL: 'Pieniądze dojdą najpóźniej następnego dnia roboczego.',

  profitCalculator: {
    transferNotSupported: 'Wybrany bank nie wspiera przelewów tej waluty.',
    transferFree: 'Nie pobieramy żadnych opłat za wysłanie wymienionych środków!',
    transferFee:
      'Za przelew do wybranego przez Ciebie banku jest pobierana opłata bankowa – {{transferFee}} PLN. Opłata została uwzględniona w wyliczeniu.',
  },
  preactSelect: {
    search: 'Szukaj...',
  },
  newsletter: {
    alreadySubscribed: 'Twój mail znajduje się już w naszym newsletterze.',
    error: 'Coś poszło nie tak. Spróbuj ponownie później.',
  },
  frontpageExitPopup: {
    accountExists: 'Wygląda na to, że masz już konto. Zniżkę wysyłamy dla nowych Klientów.',
    error: 'Wystąpił błąd',
  },
  emailValidator: {
    requiredField: 'Konieczne jest zaznaczenie tego pola',
    notEmptyField: 'To pole nie może być puste',
    minValue: 'Minimalna wartość to',
    maxValue: 'Makymalna wartość to',
    incorrectEmail: 'Podaj poprawny adres email',
    toShortPassword: 'Hasło jest za krótkie',
  },
  currencyAlert: {
    isLower: 'będzie niższy',
    isHigher: 'będzie wyższy',
    mustBeLessThan: 'Kurs musi być liczbą mniejszą od 99,9999',
    alertAlreadyExists: 'Alert kursowy dla podanego kursu już istnieje',
    maxAlerts: 'Nie możesz zapisać się na większą ilość alertów. (max. 10)',
    error: 'Coś poszło nie tak, spróbuj za chwilę.',
    alertHash: 'alert-walutowy',
    averageRateNotAvailable:
      'Obecnie nie możemy ustawić alertu, ponieważ kurs {{currency}} jest tymczasowo niedostępny. ({{averageRate}}).',
  },
  ratesUpdate: {
    update: 'Trwa aktualizowanie kursów...',
    success: 'Następna aktualizacja kursu za',
    error: 'Nie udało się pobrać danych. Ponawiam za',
  },
  currencyAnnotations: {
    notSupported: 'Wymiana tej waluty nie jest obecnie możliwa',
  },
  currencies: {
    AED: 'Dirham ZEA',
    ARS: 'Peso argentyńskie',
    AUD: 'Dolar australijski',
    BDT: 'Taka bengalska',
    BGN: 'Lew bułgarski',
    BRL: 'Real brazylijski',
    CAD: 'Dolar kanadyjski',
    CHF: 'Frank szwajcarski',
    CLP: 'Peso chilijskie',
    CNY: 'Juan chiński',
    COP: 'Peso kolumbijskie',
    CZK: 'Korona czeska',
    DKK: 'Korona duńska',
    EGP: 'Funt egipski',
    EUR: 'Euro',
    FJD: 'Dolar fidżi',
    GBP: 'Funt brytyjski',
    GHS: 'Cedi ghańskie',
    HKD: 'Dolar hongkoński',
    HUF: 'Forint węgierski',
    ILS: 'Nowy szekel izraelski',
    INR: 'Rupia indyjska',
    JOD: 'Dinar jordański',
    JPY: 'Jen japoński',
    KWD: 'Dinar kuwejcki',
    LSL: 'Loti lesotyjskie',
    MAD: 'Dirham marokański',
    MXN: 'Peso meksykańskie',
    NOK: 'Korona norweska',
    NPR: 'Rupia nepalska',
    NZD: 'Dolar nowozelandzki',
    OMR: 'Rial omański',
    PEN: 'Sol peruwiański',
    PGK: 'Kina papuańska',
    PLN: 'Polski złoty',
    RON: 'Leja rumuńska',
    RUB: 'Rubel rosyjski',
    SAR: 'Rial saudyjski',
    SEK: 'Korona szwedzka',
    SGD: 'Dolar singapurski',
    SZL: 'Lilangeni',
    THB: 'Bat tajlandzki',
    TRY: 'Lira turecka',
    USD: 'Dolar amerykański',
    UYU: 'Peso urugwajskie',
    WST: 'Tala samoańska',
    ZAR: 'Rand południowoafrykański',
  },
  currenciesDopelniacz: {
    AED: 'Dirhama ZEA',
    ARS: 'Peso argentyńskiego',
    AUD: 'Dolara australijskiego',
    BDT: 'Taki banglijskiej',
    BGN: 'Lewa bułgarskiego',
    BRL: 'Reala brazylijskiego',
    CAD: 'Folara kanadyjskiego',
    CHF: 'Franka',
    CNY: 'Juana chinśkiego',
    CZK: 'Korony czeskiej',
    DKK: 'Korony duńskiej',
    EGP: 'Funta egipskiego',
    EUR: 'Euro',
    FJD: 'Dolara fidżyjskiego',
    GBP: 'Funta',
    GHS: 'Cedi ghańskiego',
    HKD: 'Dolara hongkońskiego',
    HUF: 'Forinta węgierskiego',
    ILS: 'Szekla izraelskiego',
    INR: 'Rupii indyjskiej',
    JOD: 'Dinara jordańskiego',
    JPY: 'Jena japońskiego',
    KWD: 'Dinara kuwejckiego',
    LSL: 'Loti lesotyjskiej',
    MAD: 'Dirhama marokańskiego',
    MXN: 'Peso meksykańskiego',
    NOK: 'Korony norweskiej',
    NPR: 'Rupii nepalskiej',
    NZD: 'Dolara nowozelandzkiego',
    OMR: 'Riala omańskiego',
    PEN: 'Sol peruwiańskiego',
    PGK: 'Kiny papuaskiej',
    PLN: 'Złotego',
    RON: 'Leja rumuńskiego',
    RUB: 'Rubla rosyjskiego',
    SAR: 'Riala saudyjskiego',
    SEK: 'Korony szwedzkiej',
    SGD: 'Dolara singapurskiego',
    SZL: 'Lilangeni suazyjskiego',
    THB: 'Bata tajlandzkiego',
    TRY: 'Liry tureckiej',
    USD: 'Dolara',
    UYU: 'Peso urugwajskiego',
    WST: 'Tali samoańskiej',
    ZAR: 'Randa południowoafrykańskiego',
  },
  chart: {
    time: 'Czas',
    rate: 'Kurs',
    opening: 'Otwarcie',
    highest: 'Najwyższy',
    lowest: 'Najniższy',
    closing: 'Zamknięcie',
    monthNames: ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'],
    dayNames: ['pon', 'wto', 'śro', 'czw', 'pią', 'sob', 'nie'],
  },
  landingForm: {
    show: 'Pokaż',
    hide: 'Ukryj',
    requiredField: 'Konieczne jest zaznaczenie tego pola',
    notEmptyField: 'To pole nie może być puste',
    incorrectEmail: 'Podaj poprawny adres email',
    toShortPassword: 'Hasło jest za krótkie',
    invalidPromocode: 'Promocja dostępna na tej stronie się skończyła - zarejestruj się przez stronę główną',
    emailAlreadyExists: 'Ten e&#8209;mail nie może być użyty do rejestracji',
    generalInvalid: 'Coś poszło nie tak, spróbuj ponownie później',
    competitionFormThanks: 'Dziękujemy za udział w konkursie!',
  },
  networkErrorStatus: {
    slow: 'Problem z pobraniem kursów walut. Wolne połączenie z internetem.',
    noNetwork: 'Problem z pobraniem kursów walut. Sprawdź czy masz połączenie z internetem.',
    default: 'Wystąpiły problemy techniczne. Skontatuj się z obsługą klienta.',
  },
  calculatorForegin: {
    continueButton: 'Wyślij pieniądze',
    exchangeRates: 'Kurs wymiany',
    details: 'Szczegóły',
    amountYouSend: 'Kwota, którą wpłacam',
    countryYouSendMoney: 'Kraj, do którego wyślesz pieniądze',
    foreignTransferFee: 'Opłata za przelew zagraniczny',
    foreignTransferType: 'Typ przelewu zagranicznego',
    exchangeAmount: 'Kwota wymiany',
    amountRecipientReceive: 'Kwota, którą otrzyma odbiorca',
    minAmount: 'Kwota wymiany jest zbyt niska.',
    notSellCurrency: 'Sprzedaż waluty jest niedostępna.',
    transferTypes: {
      INTERNAL: {
        name: 'INTERNAL',
        desc: 'Pieniądze dojdą w około 30 minut od momentu kiedy otrzymamy Twój przelew, najpóźniej kolejnego dnia roboczego.',
      },
      TODAY: {
        name: 'TODAY',
        desc: 'Pieniądze dojdą najpóźniej następnego dnia roboczego.',
      },
      TODAY_OUR: {
        name: 'TODAY OUR',
        desc: 'Pieniądze dojdą najpóźniej następnego dnia roboczego.',
      },
      SEPA: {
        name: 'SEPA',
        desc: 'Pieniądze dojdą w ciągu 1 - 2 dni roboczych.',
      },
      SEPA_INSTANT: {
        name: 'SEPA INSTANT',
        desc: 'Pieniądze dojdą w około minutę.',
      },
      SPOT: {
        name: 'SPOT',
        desc: 'Pieniądze dojdą w ciągu 2 - 3 dni roboczych.',
      },
      ELIXIR: {
        name: 'ELIXIR',
        desc: 'Pieniądze dojdą najpóźniej następnego dnia roboczego.',
      },
      LOCAL: {
        name: 'LOCAL',
        desc: 'Pieniądze dojdą najpóźniej następnego dnia roboczego.',
      },
    },
  },
  timer: {
    update: 'Aktualizacja za:',
    timeUnit: 'sek.',
  },
  countries: {
    AD: 'Andora',
    AE: 'Zjednoczone Emiraty Arabskie',
    AF: 'Afganistan',
    AG: 'Antigua i Barbuda',
    AI: 'Anguilla',
    AL: 'Albania',
    AM: 'Armenia',
    AN: 'Antyle Holenderskie',
    AO: 'Angola',
    AQ: 'Antarktyka',
    AR: 'Argentyna',
    AS: 'Samoa Amerykańskie',
    AT: 'Austria',
    AU: 'Australia',
    AW: 'Aruba',
    AX: 'Wyspy Alandzkie',
    AZ: 'Azerbejdżan',
    BA: 'Bośnia i Hercegowina',
    BB: 'Barbados',
    BD: 'Bangladesz',
    BE: 'Belgia',
    BF: 'Burkina Faso',
    BG: 'Bułgaria',
    BH: 'Bahrajn',
    BI: 'Burundi',
    BJ: 'Benin',
    BL: 'Saint Barthélemy',
    BM: 'Bermudy',
    BN: 'Brunei Darussalam',
    BO: 'Boliwia',
    BR: 'Brazylia',
    BS: 'Bahamy',
    BT: 'Bhutan',
    BV: 'Wyspa Bouveta',
    BW: 'Botswana',
    BY: 'Białoruś',
    BZ: 'Belize',
    CA: 'Kanada',
    CC: 'Wyspy Kokosowe',
    CD: 'Demokratyczna Republika Konga',
    CF: 'Republika Środkowej Afryki',
    CG: 'Kongo',
    CH: 'Szwajcaria',
    CI: 'Wybrzeże Kości Słoniowej',
    CK: 'Wyspy Cooka',
    CL: 'Chile',
    CM: 'Kamerun',
    CN: 'Chiny',
    CO: 'Kolumbia',
    CR: 'Kostaryka',
    CU: 'Kuba',
    CV: 'Wyspy Zielonego Przylądka',
    CW: 'Curaçao',
    CX: 'Wyspa Bożego Narodzenia',
    CY: 'Cypr',
    CZ: 'Czechy',
    DE: 'Niemcy',
    DJ: 'Dżibuti',
    DK: 'Dania',
    DM: 'Dominika',
    DO: 'Republika Dominikańska',
    DZ: 'Algieria',
    EC: 'Ekwador',
    EE: 'Estonia',
    EG: 'Egipt',
    EH: 'Sahara Zachodnia',
    ER: 'Erytrea',
    ES: 'Hiszpania',
    ET: 'Etiopia',
    FI: 'Finlandia',
    FJ: 'Fidżi',
    FK: 'Falklandy',
    FM: 'Mikronezja',
    FO: 'Wyspy Owcze',
    FR: 'Francja',
    GA: 'Gabon',
    GB: 'Wielka Brytania',
    GD: 'Grenada',
    GE: 'Gruzja',
    GF: 'Gujana Francuska',
    GG: 'Wyspa Guernsey',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GL: 'Grenlandia',
    GM: 'Gambia',
    GN: 'Gwinea',
    GP: 'Gwadelupa',
    GQ: 'Gwinea Równikowa',
    GR: 'Grecja',
    GS: 'Georgia Południowa i Sandwich Południowy',
    GT: 'Gwatemala',
    GU: 'Guam',
    GW: 'Gwinea Bissau',
    GY: 'Gujana',
    HK: 'Hongkong',
    HM: 'Wyspy Heard i McDonalda',
    HN: 'Honduras',
    HR: 'Chorwacja',
    HT: 'Haiti',
    HU: 'Węgry',
    ID: 'Indonezja',
    IE: 'Irlandia',
    IL: 'Izrael',
    IM: 'Wyspa Man',
    IN: 'Indie',
    IO: 'Terytorium Brytyjskie Oceanu Indyjskiego',
    IQ: 'Irak',
    IR: 'Iran',
    IS: 'Islandia',
    IT: 'Włochy',
    JE: 'Wyspa Jersey',
    JM: 'Jamajka',
    JO: 'Jordania',
    JP: 'Japonia',
    KE: 'Kenia',
    KG: 'Kirgistan',
    KH: 'Kambodża',
    KI: 'Kiribati',
    KM: 'Komory',
    KN: 'Saint Kitts i Nevis',
    KP: 'Korea Północna',
    KR: 'Korea Południowa',
    KW: 'Kuwejt',
    KY: 'Kajmany',
    KZ: 'Kazachstan',
    LA: 'Laos',
    LB: 'Liban',
    LC: 'Saint Lucia',
    LI: 'Liechtenstein',
    LK: 'Sri Lanka',
    LR: 'Liberia',
    LS: 'Lesotho',
    LT: 'Litwa',
    LU: 'Luksemburg',
    LV: 'Łotwa',
    LY: 'Libia',
    MA: 'Maroko',
    MC: 'Monako',
    MD: 'Mołdawia',
    ME: 'Czarnogóra',
    MF: 'Sint Maarten',
    MG: 'Madagaskar',
    MH: 'Wyspy Marshalla',
    MK: 'Macedonia',
    ML: 'Mali',
    MM: 'Birma',
    MN: 'Mongolia',
    MO: 'Makau, Specjalny Region Administracyjny Chin',
    MP: 'Mariany Północne',
    MQ: 'Martynika',
    MR: 'Mauretania',
    MS: 'Montserrat',
    MT: 'Malta',
    MU: 'Mauritius',
    MV: 'Malediwy',
    MW: 'Malawi',
    MX: 'Meksyk',
    MY: 'Malezja',
    MZ: 'Mozambik',
    NA: 'Namibia',
    NC: 'Nowa Kaledonia',
    NE: 'Niger',
    NF: 'Wyspa Norfolk',
    NG: 'Nigeria',
    NI: 'Nikaragua',
    NL: 'Holandia',
    NO: 'Norwegia',
    NP: 'Nepal',
    NR: 'Nauru',
    NU: 'Niue',
    NZ: 'Nowa Zelandia',
    OM: 'Oman',
    PA: 'Panama',
    PE: 'Peru',
    PF: 'Polinezja Francuska',
    PG: 'Papua Nowa Gwinea',
    PH: 'Filipiny',
    PK: 'Pakistan',
    PL: 'Polska',
    PM: 'Saint-Pierre i Miquelon',
    PN: 'Pitcairn',
    PR: 'Portoryko',
    PS: 'Palestyna',
    PT: 'Portugalia',
    PW: 'Palau',
    PY: 'Paragwaj',
    QA: 'Katar',
    RE: 'Reunion',
    RO: 'Rumunia',
    RS: 'Serbia',
    RU: 'Rosja',
    RW: 'Rwanda',
    SA: 'Arabia Saudyjska',
    SB: 'Wyspy Salomona',
    SC: 'Seszele',
    SD: 'Sudan',
    SE: 'Szwecja',
    SG: 'Singapur',
    SH: 'Wyspa Świętej Heleny',
    SI: 'Słowenia',
    SJ: 'Svalbard i Jan Mayen',
    SK: 'Słowacja',
    SL: 'Sierra Leone',
    SM: 'San Marino',
    SN: 'Senegal',
    SO: 'Somalia',
    SR: 'Surinam',
    ST: 'Wyspy Świętego Tomasza i Książęca',
    SV: 'Salwador',
    SY: 'Syria',
    SZ: 'Suazi',
    TC: 'Turks i Caicos',
    TD: 'Czad',
    TF: 'Francuskie Terytoria Południowe',
    TG: 'Togo',
    TH: 'Tajlandia',
    TJ: 'Tadżykistan',
    TK: 'Tokelau',
    TL: 'Timor Wschodni',
    TM: 'Turkmenistan',
    TN: 'Tunezja',
    TO: 'Tonga',
    TR: 'Turcja',
    TT: 'Trynidad i Tobago',
    TV: 'Tuvalu',
    TW: 'Tajwan',
    TZ: 'Tanzania',
    UA: 'Ukraina',
    UG: 'Uganda',
    UM: 'Dalekie Wyspy Mniejsze Stanów Zjednoczonych',
    US: 'Stany Zjednoczone',
    UY: 'Urugwaj',
    UZ: 'Uzbekistan',
    VA: 'Watykan',
    VC: 'Saint Vincent i Grenadyny',
    VE: 'Wenezuela',
    VG: 'Brytyjskie Wyspy Dziewicze',
    VI: 'Wyspy Dziewicze Stanów Zjednoczonych',
    VN: 'Wietnam',
    VU: 'Vanuatu',
    WF: 'Wallis i Futuna',
    WS: 'Samoa',
    XK: 'Kosowo',
    YE: 'Jemen',
    YT: 'Majotta',
    ZA: 'Republika Południowej Afryki',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
  },
}
